module.exports = __webpack_public_path__ + "img/Andaluza-26-min.75b68382.jpg";